import { action, json } from "@solidjs/router";
import { submitLogin } from "../roma-api/account";
import { revalidateOnSession } from "../session";

export const loginAction = action(
  async (username: string, password: string) => {
    "use server";
    const response = await submitLogin(username, password);
    return json(response, { revalidate: revalidateOnSession });
  },
);
